export const CircleExclamationSolid = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12,24c6.63,0,12-5.37,12-12S18.63,0,12,0,0,5.37,0,12s5.37,12,12,12Zm0-18c.62,0,1.12,.5,1.12,1.12v5.25c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12V7.12c0-.62,.5-1.12,1.12-1.12Zm1.5,10.5c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5,.67-1.5,1.5-1.5,1.5,.67,1.5,1.5Z" />
    </svg>
  );
};
